/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

// import { LogLevel } from "@azure/msal-browser";

// /**
//  * Configuration object to be passed to MSAL instance on creation. 
//  * For a full list of MSAL.js configuration parameters, visit:
//  * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
//  */
// export const msalConfig = {
//     //DEV
//     // auth: {
//     //     clientId: "4aea20ec-4849-4483-904e-cbfb29be466e",
//     //     authority: "https://login.microsoftonline.com/1f60c692-db56-4f6a-abca-dd4beac49301",
//     //     redirectUri: document.location.href.split('/')[0] + '//' + document.location.href.split('/')[2] + '/signin'
//     // },
//     // BAT - Thrive QA
//     // auth: {
//     //     clientId: "90c3eb91-a8cc-47fb-9986-39322b5a7c2f",
//     //     authority: "https://login.microsoftonline.com/ff9c7474-421d-4957-8d47-c4b64dec87b5",
//     //     redirectUri: document.location.href.split('/')[0] + '//' + document.location.href.split('/')[2] + '/signin'
//     // },
//     //BAT - Thrive PRD
//     auth: {
//         clientId: "97134ada-96bb-4b26-87d6-2e14e9d3480e",
//         authority: "https://login.microsoftonline.com/ff9c7474-421d-4957-8d47-c4b64dec87b5",
//         redirectUri: document.location.href.split('/')[0] + '//' + document.location.href.split('/')[2] + '/signin'
//     },
//     cache: {
//         cacheLocation: "sessionStorage", // This configures where your cache will be stored
//         storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
//     },
//     system: {	
//         loggerOptions: {	
//             loggerCallback: (level, message, containsPii) => {	
//                 if (containsPii) {		
//                     return;		
//                 }		
//                 switch (level) {		
//                     case LogLevel.Error:		
//                         console.error(message);		
//                         return;		
//                     case LogLevel.Info:		
//                         console.info(message);		
//                         return;		
//                     case LogLevel.Verbose:		
//                         console.debug(message);		
//                         return;		
//                     case LogLevel.Warning:		
//                         console.warn(message);		
//                         return;		
//                 }	
//             }	
//         }	
//     }
// };

// /**
//  * Scopes you add here will be prompted for user consent during sign-in.
//  * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
//  * For more information about OIDC scopes, visit: 
//  * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
//  */
// export const loginRequest = {
//     // DEV
//     // scopes: ["api://eae5a3aa-01c3-486d-9db6-e944243a21eb/apiorca-qa"]
//     //BAT - Quality QA
//     // scopes: ["api://59b48447-218b-45cf-83f6-2b430f746c44/apiquality-qa/user_impersonation"]
//     // BAT - Thrive PRD
//     scopes: ["api://73eec656-0425-46c4-a2b2-2cd98ec976ba/apiquality/user.read"]
// };

// /**
//  * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
//  * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
//  */
// export const graphConfig = {
//     graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
// };

import { LogLevel } from "@azure/msal-browser";

/**
 * Detecta o ambiente atual da mesma forma que getEnvironmentApiUrl() no api.jsx:
 * - Em dev local (NODE_ENV=development), retorna DEV
 * - Se o host contiver "qualityapp-...-dev", DEV
 * - Se for "…-test", QA
 * - Se for "…-prod", PROD
 * - Se for "…-staging", considera QA (pré-prod)
 * - Se host começa com "qa.", QA
 * - Se host começa com "guardian360", PROD
 */
function detectEnvironment() {
  if (process.env.NODE_ENV === "development") {
    return "DEV";
  }

  const host = window.location.host.toLowerCase();

  if (host.startsWith("bat")) {
    const parts = host.split("-");
    if (parts.length > 2) {
      const envPart = parts[2];
      if (envPart.startsWith("dev")) {
        return "DEV";
      }
      if (envPart.startsWith("qa")) {
        return "QA";
      }
      if (envPart.startsWith("staging")) {
        return "PROD";
      }
    }
    else {
      return "PROD";
    } 
  }

  if (host.startsWith("qa-guardian360")) {
    return "QA";
  }

  if (host.startsWith("guardian360")) {
    return "PROD";
  }

  // fallback seguro
  return "PROD";
}

const ENV = detectEnvironment();

const envConfigs = {
  DEV: {
    auth: {
      clientId: "4aea20ec-4849-4483-904e-cbfb29be466e",
      authority: "https://login.microsoftonline.com/1f60c692-db56-4f6a-abca-dd4beac49301",
      redirectUri: document.location.href.split('/')[0] + '//' + document.location.href.split('/')[2] + '/signin'
    },
    scopes: ["api://eae5a3aa-01c3-486d-9db6-e944243a21eb/apiorca-qa"]
  },
  QA: {
    auth: {
      clientId: "90c3eb91-a8cc-47fb-9986-39322b5a7c2f",
        authority: "https://login.microsoftonline.com/ff9c7474-421d-4957-8d47-c4b64dec87b5",
        redirectUri: document.location.href.split('/')[0] + '//' + document.location.href.split('/')[2] + '/signin'
    },
    scopes: ["api://59b48447-218b-45cf-83f6-2b430f746c44/apiquality-qa/user_impersonation"]
  },
  PROD: {
    auth: {
      clientId: "97134ada-96bb-4b26-87d6-2e14e9d3480e",
        authority: "https://login.microsoftonline.com/ff9c7474-421d-4957-8d47-c4b64dec87b5",
        redirectUri: document.location.href.split('/')[0] + '//' + document.location.href.split('/')[2] + '/signin'
    },
    scopes: ["api://73eec656-0425-46c4-a2b2-2cd98ec976ba/apiquality/user.read"]
  }
};

const { auth, scopes } = envConfigs[ENV];

export const msalConfig = {
  auth,
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:   console.error(message); break;
          case LogLevel.Info:    console.info(message);  break;
          case LogLevel.Verbose: console.debug(message); break;
          case LogLevel.Warning: console.warn(message);  break;
        }
      }
    }
  }
};

export const loginRequest = {
  scopes
};
